module.exports = __webpack_public_path__ + "static/media/shaolaishan_plant.1dcaec5e.webp";